module.exports = __webpack_public_path__ + "img/suit-09.7a5ea209.png";